import config from 'emun.retailer/retailer.config'
import $appConfig from 'servicestack/config'

class DashboardShippingCostsController  {
    constructor(createAutoQuery, $session, $scope) {
        let $ctrl = this;
        let options = {
            url: 'QueryFreightTotals.json',
            criteria: {
                dateRange: $ctrl.date,
                startDate: $ctrl.start,
                endDate: $ctrl.end,
                vendorId: $ctrl.vendor
            },
            autoLoad: true
        };
        $ctrl.query = createAutoQuery(options);
        $ctrl.productImage = $appConfig.productImage;
        $ctrl.$session = $session;
        $scope.$watch("$ctrl.date", function () {
            $ctrl.reload();
        });
        $scope.$watch("$ctrl.start", function () {
            $ctrl.reload();
        });
        $scope.$watch("$ctrl.end", function () {
            $ctrl.reload();
        });
        $scope.$watch("$ctrl.vendor", function () {
            $ctrl.reload();
        });
    }
    reload() {
        this.query.criteria.dateRange = this.date;
        this.query.criteria.startDate = this.start;
        this.query.criteria.endDate = this.end;
        this.query.criteria.vendorId = this.vendor;
        this.query.load(true);
    }
}

class DashboardShippingCosts{
    constructor(){
        this.bindings= {
            date: '@',
            start: '@',
            end: '@',
            vendor: '@'
        };
        this.controller = DashboardShippingCostsController;
    }

    templateUrl($element, $attrs) {
        return $attrs.templateUrl || 'dashboard-shipping-costs.html'
    }
}

angular.module('emun.shopping.admin').component('dashboardShippingCosts', new DashboardShippingCosts());

export default DashboardShippingCosts